import { render, staticRenderFns } from "./investigateAndSurvey.vue?vue&type=template&id=63e9a53b&scoped=true&"
import script from "./investigateAndSurvey.vue?vue&type=script&lang=js&"
export * from "./investigateAndSurvey.vue?vue&type=script&lang=js&"
import style0 from "./investigateAndSurvey.vue?vue&type=style&index=0&id=63e9a53b&prod&lang=scss&"
import style1 from "./investigateAndSurvey.vue?vue&type=style&index=1&id=63e9a53b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e9a53b",
  null
  
)

export default component.exports